import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBOJk0sqgXPz75mGGFu12zsqMtsm2RDO6I",
  authDomain: "terror-tcg.firebaseapp.com",
  databaseURL: "https://terror-tcg-default-rtdb.firebaseio.com",
  projectId: "terror-tcg",
  storageBucket: "terror-tcg.firebasestorage.app",
  messagingSenderId: "47395896249",
  appId: "1:47395896249:web:59ae23e554366159c09468"
};

const app = initializeApp(firebaseConfig);
export const db   = getDatabase(app);
export const auth = getAuth(app);

// ════════════════════════════════════════════════════════════════════
// ⬡ THE DRAWER — IE_FIREBASE_LAW §2
// ────────────────────────────────────────────────────────────────────
// "All game-owned data under games/{game_id}/..., through ONE BASE path
//  constant, never scattered path strings. NEVER a new top-level node."
//
// This exists because three features shipped on 2026-08-18 taking new
// TOP-LEVEL nodes — factionWars/, replays/, tournaments/ — on the
// mistaken belief that §1's new-field exemption covered them. It does
// not: §1 is about new fields under profiles/{uid}, which genuinely
// have no $extra guard. A new top-level node is a different thing, and
// rules.json ends with `"$other": { ".read": false, ".write": false }`.
//
// So all three would have failed every read and write with
// permission_denied on caP'n's live database — and two of them were
// written fire-and-forget, so they would have failed SILENTLY. The
// tally would never have incremented; no replay would ever have saved.
// Every test passed because no test talks to Firebase.
//
// Under games/{gameId} the `$gameId` wildcard already grants
// read+write to any authed player, so this needed ZERO rules deploy —
// the law's own drawer was the fix.
//
// SHARED things stay OUT of here (§3): profiles/, matches/, leaderboard/
// are cross-game or grandfathered and keep their paths.
export const GAME_BASE = "games/terror";
